// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Code Components Area
export class AreaCodeComponents {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Fetches all remote code components in the design system
     * @param designSystemId - ID of the design system
     * @returns All code components in the specified design system
     */
    async getCodeComponents(designSystemId) {
        return this.dataCore.codeComponents(designSystemId);
    }
    /** Fetches AI-generated markdown for a requested batch of code components
     * @param designSystemId - ID of the design system
     * @param components - Components to fetch markdown for, as { packageName, componentName } pairs
     * @returns Resolved markdown for found components and a list of components without markdown
     */
    async getCodeComponentMarkdown(designSystemId, components) {
        return this.dataCore.codeComponentMarkdown(designSystemId, components);
    }
    /** Fetches all remote code component usage in the design system
     * @param designSystemId - ID of the design system
     * @returns All code component usage in the specified design system
     */
    async getCodeComponentUsage(designSystemId) {
        return this.dataCore.codeComponentUsage(designSystemId);
    }
    /** Fetches code scan history with optional filters
     * @param designSystemId - ID of the design system
     * @param query - Optional filters (time range, packages, component names, repos)
     * @returns Code history snapshots
     */
    async getCodeHistory(designSystemId, query) {
        return this.dataCore.codeHistory(designSystemId, query);
    }
    /** Fetches all code scans for a design system
     * @param designSystemId - ID of the design system
     * @returns All code scans
     */
    async getCodeScans(designSystemId) {
        return this.dataCore.codeScans(designSystemId);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Delete
    /** Deletes a specific code scan
     * @param designSystemId - ID of the design system
     * @param scanId - ID of the scan to delete
     */
    async deleteCodeScan(designSystemId, scanId) {
        return this.dataCore.deleteCodeScan(designSystemId, scanId);
    }
}
